import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import './DlUnitEdit.scss';
import { Form, Button } from 'react-bootstrap';
import { getUser, newUserInit, saveUser } from "../../actions";
import User from '../../models/User';


const mapStateToProps = (state) => ({
    user: state.user.user
});

const mapDispatchToProps = (dispatch) => ({
    getUser: (payload) => dispatch(getUser(payload)),
    newUserInit: () => dispatch(newUserInit()),
    saveUser: (payload) => dispatch(saveUser(payload)),  
});

const UserEdit = ({ match, user, getUser, newUserInit, saveUser }) => {
    const itemId = ( 'itemId' in match.params ? match.params.itemId : '' );
    let fRefUn = React.createRef();
    let fRefEmail = React.createRef();
    let fRefFirstName = React.createRef();
    let fRefLastName = React.createRef();
    let fRefUType = React.createRef();
    let fRefPw = React.createRef();
    let fRefPwRe = React.createRef();
    let [fCond, setFCond] = useState({});    

    useEffect(function() {
        console.log('itemId');
        console.log(itemId);        
        
        if (itemId!=='') {
            getUser(itemId);
        } else {
            newUserInit();
        }
    }, [itemId]);

    const saveItem = (ev) => {
        const un = fRefUn.current.value;
        let pw = fRefPw.current.value;
        const pwRe = fRefPwRe.current.value;
        let ch = true;
        let msg = '';
        if (un == '') {
            ch = false;
            msg = 'Polje za korisnicko ime ne sme biti prazno. ';            
        }
        if (pw != '') {
            if (pw != pwRe) {
                ch = false;
                msg = 'Polja za lozinku i ponovljenu lozinku moraju imati istu vrednost. ';                            
            }
        } else {
            pw = user.pw;
        }

        if (ch) {
            let item = new User();
            item.obSet({ 
                un,
                pw,
                email: fRefEmail.current.value,
                uType: fRefUType.current.value,
                firstName: fRefFirstName.current.value,
                lastName: fRefLastName.current.value,
            });
            saveUser({ itemId: user.id, item });                
        } else {
            alert(msg);            
        }
    };

    return (
        <Form style={{ 'marginLeft': '0%' }} onSubmit={saveItem}>
            <Form.Group>
                <Form.Label>Korisnicko ime</Form.Label>
                <Form.Control type="text" ref={fRefUn} defaultValue={user.un} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control type="text" ref={fRefEmail} defaultValue={user.email} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Ime</Form.Label>
                <Form.Control type="text" ref={fRefFirstName} defaultValue={user.firstName} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Prezime</Form.Label>
                <Form.Control type="text" ref={fRefLastName} defaultValue={user.lastName} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Tip korisnika</Form.Label>
                <Form.Control type="text" ref={fRefUType} defaultValue={user.uType} />
            </Form.Group>
            <Form.Group style={{ marginTop: '1em' }}>
                <Form.Label>Lozinka</Form.Label>
                <Form.Control type="password" ref={fRefPw} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Ponovljena lozinka</Form.Label>
                <Form.Control type="password" ref={fRefPwRe} />
            </Form.Group>
            <Button variant="primary" type="button" onClick={saveItem} style={{ marginTop: '1em' }}>
            OK
            </Button>
        </Form>
    );

}

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit);
